import React, { createContext, useContext, useState } from 'react';

const FilterContext = createContext();

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilter must be used within a FilterProvider');
  }
  return context;
};

export const FilterProvider = ({ children }) => {
  const [filters, setFilters] = useState({});

  const updateFilters = (pageKey, newFilters) => {
    setFilters(prev => ({
      ...prev,
      [pageKey]: {
        ...prev[pageKey],
        ...newFilters
      }
    }));
  };

  const clearFilters = (pageKey) => {
    setFilters(prev => {
      const newFilters = { ...prev };
      delete newFilters[pageKey];
      return newFilters;
    });
  };

  const clearAllFilters = () => {
    setFilters({});
  };

  const getFilters = (pageKey) => {
    return filters[pageKey] || {};
  };

  return (
    <FilterContext.Provider value={{ filters, updateFilters, clearFilters, clearAllFilters, getFilters }}>
      {children}
    </FilterContext.Provider>
  );
}; 